import { z } from 'zod'

const metadata = z.object({
  id: z.string(),
  createdAt: z.string(),
  createdBy: z.string(),
  updatedAt: z.string(),
  updatedBy: z.string(),
  syncAt: z.string().nullish(),
})

type MetadataDto = z.infer<typeof metadata>

const ParamsId = z.object({
  id: z.string(),
})

const DateRangeDto = z.object({
  from: z.coerce.date(),
  to: z.coerce.date().nullish(),
})

export type DateRangeDto = z.infer<typeof DateRangeDto>

export const zh = {
  metadata,
  ParamsId,
  DateRangeDto,
}

type OmitMetadata<T> = Omit<
  T,
  'id' | 'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy' | 'syncAt'
>

export type { MetadataDto, OmitMetadata }
